<template>
  <el-form
    ref="form"
    label-position="top"
    :model="form"
    :rules="rules"
    @submit.native.prevent="submit"
  >
    <h1>Neues Passwort setzen</h1>

    <el-card v-if="errors.password.length">
      <el-alert
        v-for="error in errors.password"
        :key="error"
        :closable="false"
        show-icon
        :title="error"
        type="error"
      />
    </el-card>

    <el-row :gutter="32">
      <el-col :md="12">
        <el-form-item
          for="password"
          label="Neues Passwort"
          prop="password"
        >
          <el-input
            id="password"
            v-model="form.password"
            type="password"
          />
        </el-form-item>
      </el-col>

      <el-col :md="12">
        <el-form-item
          for="password-repeat"
          label="Passwort wiederholen"
          prop="passwordRepeat"
        >
          <el-input
            id="password-repeat"
            v-model="form.passwordRepeat"
            type="password"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-form-item>
      <el-button
        :loading="resetStatus === $config.status.LOADING"
        native-type="submit"
        round
        type="primary"
      >
        Speichern
      </el-button>

      <c-button-link
        :to="{ name: 'login' }"
        round
      >
        Zum Login
      </c-button-link>
    </el-form-item>
  </el-form>
</template>

<script>
import CButtonLink from '@/components/CButtonLink'

import api from '@/api'
import validators from '@/functions/validators'

export default {
  name: 'VPasswordSetNew',

  metaInfo: {
    title: 'Passwort setzen'
  },

  components: {
    CButtonLink
  },

  props: {
    token: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      resetStatus: this.$config.status.IDLE,
      form: {
        password: '',
        passwordRepeat: ''
      },
      errors: {
        password: []
      },
      rules: {
        password: [
          {
            required: true,
            message: 'Bitte geben Sie ein neues Passwort ein.'
          },
          {
            validator: (rule, value, callback) => {
              validators.validateField({
                form: this.$refs.form,
                field: 'passwordRepeat',
                fieldValue: this.form.passwordRepeat,
                callback
              })
            }
          }
        ],
        passwordRepeat: [
          {
            required: true,
            message: 'Bitte wiederholen Sie Ihr Passwort.'
          },
          {
            validator: (rule, value, callback) => {
              validators.compare({
                value,
                comparison: this.form.password,
                message: 'Bitte wiederholen Sie Ihr Passwort.',
                callback
              })
            }
          }
        ]
      }
    }
  },

  methods: {
    resetErrors () {
      this.errors.password = []
    },
    submit () {
      this.resetErrors()

      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }

        this.resetStatus = this.$config.status.LOADING

        api.password
          .setNew({ token: this.token, ...this.form })
          .then(response => {
            this.resetStatus = this.$config.status.SUCCESS

            this.$notify.success({
              title: 'Passwort gespeichert',
              message: 'Ihr neues Passwort wurde erfolgreich gespeichert.'
            })

            this.$router.push({ name: 'login' })
          })
          .catch(error => {
            if (error.response && error.response.status === 400) {
              this.errors.password = error.response.data
            } else {
              this.$notify.error({
                title: 'Fehler',
                message: 'Ihr neues Passwort konnte leider nicht gespeichert werden.'
              })
            }

            this.resetStatus = this.$config.status.ERROR
          })
      })
    }
  }
}
</script>
